import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import SubscriptionAlert from './componenets/Notification/SubscriptionAlert';
import ActivityReminderAlert from './componenets/Notification/ActivityReminderAlert';
import { useAuth } from './context/AuthContext';
function Header() {
  const navigate = useNavigate();
  const { user: authUser, companySettings } = useAuth();
  const [user, setUser] = useState(null);
  const [dashboardLink, setDashboardLink] = useState('');

  useEffect(() => {
    const userInfoFromStorage = localStorage.getItem('user-info');
    if (userInfoFromStorage) {
      const userInfo = JSON.parse(userInfoFromStorage);
      setUser(userInfo);
      const permissions = userInfo?.permissions || [];

      // Priority-based dashboard mapping
      if (permissions.includes('dashboard-main')) {
        setDashboardLink('/dashboard');
      } else if (permissions.includes('dashboard-sales')) {
        setDashboardLink('/sales-dashboard');
      } else if (permissions.includes('dashboard-account')) {
        setDashboardLink('/account-dashboard');
      } else if (permissions.includes('dashboard-operation')) {
        setDashboardLink('/operation-dashboard');
      } else {
        setDashboardLink(null); // fallback if no dashboard permission
      }

    }

    const axiosInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('user-info');
          setUser(null);
          navigate('/login');
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(axiosInterceptor);
    };
  }, [navigate]);
  const getAssetUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    return `${backendUrl}/storage/${path}`;
  };

  function logout() {
    const userInfoFromStorage = localStorage.getItem('user-info');
    const parsedUserInfo = JSON.parse(userInfoFromStorage);
    const token = parsedUserInfo?.token;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const origin = localStorage.getItem('user-origin');

    axios
      .post(`${backendUrl}/api/logout`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          localStorage.removeItem('user-info');
          setUser(null);
          navigate('/login');
        }
      })
      .catch((error) => {
        console.error('Logout failed:', error);
      });
  }

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          {/* Logo */}
          <div className="navbar-brand-box">
            <Link to={dashboardLink} className="logo logo-dark">
              <span className="logo-sm">
                {/* <img src="assets/images/logo.svg" alt="user" height={22} /> */}
              </span>
              <span className="logo-lg">
                {/* <img src="assets/images/logo-dark.png" alt="user" height={17} /> */}
              </span>
            </Link>
            <Link to={dashboardLink} className="logo logo-light">
              {/* <span className="logo-sm">
                <img src="assets/images/lOgoOnly.png" alt="user" height={22} />
              </span>
              <span className="logo-lg">
                <img src="assets/images/lOgoOnly.png" alt="user" height={19} />
              </span> */}
              <span className="logo-sm">
                {/* Show icon in small logo if available, otherwise fallback */}
                {companySettings?.icon ? (
                  <img src={getAssetUrl(companySettings.icon)} alt="icon" height={22} />
                ) : (
                  <img src="assets/images/lOgoOnly.png" alt="icon" height={22} />
                )}
              </span>
              <span className="logo-lg">
                {/* Show logo in large logo if available, otherwise fallback */}
                {companySettings?.logo ? (
                  <img src={getAssetUrl(companySettings.logo)} alt="logo" height={19} />
                ) : (
                  <img src="assets/images/lOgoOnly.png" alt="logo" height={19} />
                )}
              </span>
            </Link>
          </div>

          <button
            type="button"
            className="btn btn-sm px-3 font-size-16 header-item waves-effect"
            id="vertical-menu-btn"
          >
            {/* <i className="fa fa-fw fa-bars" /> */}
          </button>
        </div>

        <div className="d-flex align-items-center">
          {/* Notification Bell - Placed before the profile dropdown */}
          <div className="me-3 d-flex align-items-center">
            {/* <ActivityReminderAlert /> */}
            <SubscriptionAlert />
          </div>

          {/* Profile Dropdown */}
          <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item waves-effect header-align d-flex align-items-center"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="bx bx-user font-size-16 align-middle me-1" />
              <span className="d-none d-xl-inline-block ms-1" key="user-name">
                {user?.user?.name || 'User'}
              </span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block ms-1" />
            </button>
            <div className="dropdown-menu dropdown-menu-end header-dropdown">
              <div className="px-3 py-2">
                <span>Welcome,</span><span className='header-user'> {user?.user?.name || ' '}</span>
              </div>
              <hr className="dropdown-divider" />
              <Link to="/profile" className="dropdown-item">
                <i className="bx bx-user font-size-16 align-middle me-1" /> <span>Profile</span>
              </Link>
              <button onClick={logout} className="dropdown-item text-danger">
                <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" /> Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;